var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "10px",
    viewBox: "0 0 31 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Visa") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Limepay-Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "15.1-Payment-Modal-Validation",
    transform: "translate(-510.000000, -339.000000)",
    fill: "#16216A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modal",
    transform: "translate(460.000000, 275.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cards",
    transform: "translate(45.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "img-fi-visa"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Visa",
    transform: "translate(5.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3933554,0.942808163 C21.9015123,0.754651657 21.1315655,0.55164069 20.1685247,0.55164069 C17.7178106,0.55164069 15.9896807,1.80931839 15.9751075,3.61289753 C15.9605344,4.94484754 17.2077512,5.68880846 18.1489323,6.13320442 C19.1144019,6.58750335 19.4410828,6.87716534 19.4362251,7.28318727 C19.4289385,7.90459889 18.6638494,8.18807152 17.9497662,8.18807152 C16.9587936,8.18807152 16.4317322,8.04695414 15.6156371,7.70158793 L15.2962427,7.55551906 L14.9477021,9.63142999 C15.5257695,9.89014518 16.5981087,10.1142 17.7117385,10.1253408 C20.3203281,10.1253408 22.0132396,8.88251758 22.0326705,6.95638913 C22.0411715,5.90296027 21.3817375,5.0995815 19.9499278,4.43732012 C19.0816124,4.00777862 18.5509077,3.72183024 18.5545509,3.28733726 C18.5545509,2.90235915 19.0063179,2.49014785 19.9766452,2.49014785 C20.7878826,2.47653126 21.3768798,2.65726054 21.8335044,2.84417917 L22.0557446,2.95187402 L22.3933554,0.942808163",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7545251,0.722466991 L26.8381589,0.722466991 C26.244304,0.722466991 25.7998237,0.888341806 25.5399363,1.49118535 L21.8541497,9.99041279 L24.4603105,9.99041279 C24.4603105,9.99041279 24.88536,8.84785717 24.9825142,8.59780707 C25.2666901,8.59780707 27.7975564,8.60152069 28.1594558,8.60152069 C28.2335358,8.92584309 28.4618481,9.99041279 28.4618481,9.99041279 L30.7644021,9.99041279 L28.7545251,0.722466991 L28.7545251,0.722466991 Z M25.6953829,6.70138755 C25.9018356,6.16538908 26.6839267,4.10680836 26.6839267,4.10680836 C26.670568,4.13280367 26.8879505,3.57080989 27.011822,3.22173006 L27.1806274,4.02139521 C27.1806274,4.02139521 27.6566829,6.23594777 27.7562659,6.70138755 L25.6953829,6.70138755 L25.6953829,6.70138755 Z",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8318467,0.719991248 L6.40299228,7.04427803 L6.14310485,5.75936715 C5.69255236,4.27887253 4.28260237,2.672115 2.70749027,1.86873623 L4.92746322,9.97927195 L7.55305484,9.9767962 L11.4598672,0.719991248 L8.8318467,0.719991248",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.14901537,0.715039761 L0.146263287,0.715039761 L0.115902607,0.906909882 C3.22847955,1.67439037 5.28936252,3.531198 6.14310485,5.75936715 L5.27357497,1.49737471 C5.122986,0.909385626 4.68822105,0.736083581 4.14901537,0.715039761",
    id: "Fill-6"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-7",
    points: "10.9133749 9.98669918 12.4641985 0.713801889 14.9464877 0.713801889 13.3920209 9.98669918 10.9133749 9.98669918"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.d77c3fc0.svg";
export { ForwardRef as ReactComponent };